<script setup lang="ts">
</script>

<template>
    <div class="curse_item">
        <h2>{{ curse.name }}</h2>
        <p>{{ curse.description }}</p>
        <p class="price">{{ curse.price }} ₽</p>
   </div>
</template>

<script lang="ts">
interface Curse {
    name: string,
    description: string,
    type: string
}

export default {
    name: 'CurseItem',
    props: {
        curse: {} as Curse
    }
}
</script>
<style scoped>
.curse_item {
    display: flex;
    flex-direction: column;
    width: 300px;
    height: 300px;
    border: 1px solid black;
    border-radius: 10px;
    padding: 10px;
    margin: 10px;
}
.price {
    font-size: 20px;
    font-weight: bold;
    margin-top: 10px;
    align-self: flex-end;
}
</style>
